import { useContext, useEffect, useMemo, useState } from "react";
import {
  Pagination,
  Search,
  TableHeader,
} from "../../../context/components/DataTable";
import LoaderContext from "../../../context/loader/LoaderContext";
import { Link } from "react-router-dom";
import { BiEdit } from "react-icons/bi";
import axiosPrivate from "../../../hooks/axiosPrivate";
import AuthContext from "../../../context/Auth/AuthContext";

function isValidURL(string) {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
}

const DealerTable = ({ headers }) => {
  const { setIsLoading } = useContext(LoaderContext);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const filterListLengths = [10, 25, 50, 100];
  const [dealerState, setDealerState] = useState([]);
  const { checkPermissionExists, authPermissions } = useContext(AuthContext);

  function toTitleCase(str) {
    str = str.toLowerCase().split(" ");
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(" ");
  }

  const dealersList = () => {
    if (!search) {
      setIsLoading(true);
    }

    axiosPrivate
      .get(
        `dealers/paginated?page=${currentPage}&limit=${itemsPerPage}&search=${search}`
      )
      .then((dealers) => {
        const dealersData = dealers?.data?.data?.data?.map((value, key) => {
          let buttons = [];
          if (true && authPermissions.includes("Dealer-Edit"))
            buttons.push(
              <Link
                key="editButton##1"
                type="button"
                to={`/admin/dealer/edit/${value.id}`}
                className="btn btn-icon"
                title="Edit"
              >
                <BiEdit style={{ color: "green" }} size={18} />
              </Link>
            );
          value["action"] = buttons.length > 0 ? buttons : "-";
          value["roles"] = toTitleCase(value.roles);
          return value;
        });
        setTotalItems(dealers?.data?.data?.total);
        setDealerState(dealersData);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("errorr", error);
        setIsLoading(false);
      });
  };

  const changeItemsPerPage = (e) => {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    dealersList();
  }, [authPermissions, currentPage, itemsPerPage, search]);

  return (
    <>
      <div className="row">
        <div className="col mb-3  text-center">
          <div className="row mb-4">
            <div className="col-md-6 col-sm-12">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
                placeholder="Search By name"
              />
            </div>

            <div className="col-sm-12 col-md-6 d-flex flex-row-reverse mt-2">
              <div className="float-left  ml-3">
                <label className="mr-2 ">Show</label>
                <select
                  name="list_length"
                  className="form-select "
                  onChange={changeItemsPerPage}
                >
                  {filterListLengths.map((value, key) => {
                    return (
                      <option key={++key} value={value}>
                        {value}
                      </option>
                    );
                  })}
                </select>
                <span className="ml-2 ">entries</span>
              </div>
            </div>
          </div>

          {/* <table className="table table-striped table-hover table-vcenter text-nowrap mb-0 "> */}
          <div
            className="table-responsive"
            style={{ border: "1px solid #000" }}
          >
            <table
              className="table table-hover table-fixed"
              style={{ border: "none" }}
            >
              <TableHeader
                headers={headers}
                // onSorting={(field, order) => setSorting({ field, order })}
              />
              <tbody>
                {dealerState.map((comment, idx) => {
                  return (
                    <tr
                      key={idx}
                      style={{
                        backgroundColor:
                          comment?.line_break === "1" ? "#f8d7da" : "", // Conditional background color
                        cursor: "pointer", // Add pointer cursor for hover effect
                      }}
                      title={
                        comment?.line_break === "1"
                          ? "Remove space in tally for this dealer"
                          : ""
                      } // Text to show on hover
                    >
                      <td style={{ textAlign: "left" }}>
                        {idx + (currentPage - 1) * 10 + 1}
                      </td>
                      {/* Serial number data */}
                      {headers.map((col, colIdx) =>
                        col.field !== "image" ? (
                          <td
                            key={`${idx}-${colIdx}`}
                            style={{
                              textAlign: "left",
                            }}
                          >
                            {isValidURL(comment[col.field])
                              ? `${comment[col.field]
                                  ?.split("/")
                                  ?.pop()
                                  ?.split("-")
                                  ?.slice(1)
                                  ?.join("-")}`
                              : comment[col.field]}
                          </td>
                        ) : (
                          <td
                            key={`${idx}-${colIdx}`}
                            style={{ textAlign: "left" }}
                          >
                            <img
                              src={comment[col.field]}
                              style={{ width: "90px", height: "90px" }}
                            />
                          </td>
                        )
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="col-sm-12 col-md-12 d-flex justify-content-center align-items-center">
        <Pagination
          total={totalItems}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>{" "}
    </>
  );
};

export default DealerTable;
